import { login, logout, getInfo } from '@b/api/auth'
import { getToken, setToken, removeToken } from '@b/utils/auth'
import { setCookies, removeCookies } from '@b/utils/cookies'
import { resetRouter } from '@b/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { account, password } = userInfo
    return new Promise((resolve, reject) => {
      login(
        { account: account.trim(), password: password }
      )
      .then(response => {
        const { data } = response
        if(data.code === 200){
          setToken(data.data.token)
          commit('SET_TOKEN', data.data.token)
          resolve()
        }else{
          reject("帳號或密碼錯誤")
        }
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
      .then(response => {
        const { data } = response.data
        if (!data) {
          reject('讀取失敗，請重新登入')
        }
        setCookies('Admin', {admin_id: data.id})
        const { name } = data        
        commit('SET_NAME', name)
        resolve(data)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },

  // user logout
  // 不管api回應對錯，一率清空cookie登出
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).
      then(() => {
        removeToken() // must remove  token  first
        removeCookies('Admin')
        resetRouter()
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        removeToken() // must remove  token  first
        removeCookies('Admin')
        resetRouter()
        commit('RESET_STATE')
        resolve()
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      removeCookies('Admin')
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

